<div class="pageHeader">
  <h1>Lounge parties</h1>
</div>
<p class="hint">
  Une série ou une playlist regardée en groupe sur plusieurs séances : la progression du groupe
  et celle de chacun sont gardées en mémoire. Pour en créer une, ouvre une série ou une playlist
  vidéo et choisis « Créer une lounge party ».
</p>
<div class="staticGrid" id="staticGrid"></div>
